import { Box, Typography, TypographyOwnProps } from '@mui/material';

const Typographys = () => {
  const variants = ['h1', 'h2', 'h3', 'subtitle2', 'body1', 'captions'];
  return (
    <Box>
      <Typography variant="h3">Typography</Typography>
      <Box mt={2}>
        {variants.map((variant, index) => (
          <Typography
            key={index}
            variant={variant as TypographyOwnProps['variant']}
          >
            {variant}: the quick brown fox สวัสดีครับ ผมชื่อนายประหยัด
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default Typographys;
